module.exports = __webpack_public_path__ + "static/media/rana.66e71442.jpg";